{
  "rides": [
    {
      "id": "jet_snail",
      "name": "Jet Snail",
      "ability": "Dash",
      "blurb": "The fastest ride. Mud and slow strips can't slow it.",
      "price": 0,
      "currency": "coins",
      "starter": true
    },
    {
      "id": "thundertoad",
      "name": "Thundertoad",
      "ability": "Shockwave",
      "blurb": "Super jumps. Every landing stuns racers nearby.",
      "price": 0,
      "currency": "coins"
    },
    {
      "id": "wobblebot",
      "name": "Wobblebot",
      "ability": "Bulldoze",
      "blurb": "Rolls through obstacles and bumps racers aside.",
      "price": 0,
      "currency": "coins"
    },
    {
      "id": "pufferloon",
      "name": "Pufferloon",
      "ability": "Glide",
      "blurb": "Floats down gently. Hold jump to rise.",
      "price": 0,
      "currency": "coins"
    },
    {
      "id": "drillmole",
      "name": "Drillmole",
      "ability": "Burrow",
      "blurb": "Jump to dig underground, where nothing can hit you.",
      "price": 0,
      "currency": "coins"
    },
    {
      "id": "crabwalker",
      "name": "Crabwalker",
      "ability": "Shell",
      "blurb": "Its shell breaks missiles and bumps racers aside.",
      "price": 0,
      "currency": "coins"
    }
  ],
  "shop": {
    "featured": 6
  }
}
